var map = {
	"./Ubisoft-plus-cloud-gaming-devices_desktop.webp": 32,
	"./Ubisoft-plus-cloud-gaming-devices_mobile.webp": 33,
	"./Ubisoft-plus-cloud-gaming-devices_tablet.webp": 34,
	"./Ubisoft-plus-crew-2-gold-edition_desktop.webp": 35,
	"./Ubisoft-plus-crew-2-gold-edition_mobile.webp": 36,
	"./Ubisoft-plus-crew-2-gold-edition_tablet.webp": 37,
	"./Ubisoft-plus-game-library-Ubisoft-Connect_desktop.webp": 38,
	"./Ubisoft-plus-game-library-Ubisoft-Connect_mobile.webp": 39,
	"./Ubisoft-plus-game-library-Ubisoft-Connect_tablet.webp": 40,
	"./Uplayplus_LP_carousel_ACOD.webp": 41,
	"./Uplayplus_LP_carousel_ACOD_desktop.webp": 42,
	"./Uplayplus_LP_carousel_ACOD_mobile.webp": 43,
	"./Uplayplus_LP_carousel_ACOD_tablet.webp": 44,
	"./Uplayplus_LP_carousel_ACV_desktop.webp": 45,
	"./Uplayplus_LP_carousel_ACV_mobile.webp": 46,
	"./Uplayplus_LP_carousel_ACV_tablet.webp": 47,
	"./Uplayplus_LP_carousel_Anno1800_desktop.webp": 48,
	"./Uplayplus_LP_carousel_Anno1800_mobile.webp": 49,
	"./Uplayplus_LP_carousel_Anno1800_tablet.webp": 50,
	"./Uplayplus_LP_carousel_FC5_desktop.webp": 51,
	"./Uplayplus_LP_carousel_FC5_mobile.webp": 52,
	"./Uplayplus_LP_carousel_FC5_tablet.webp": 53,
	"./Uplayplus_LP_carousel_FCND_desktop.webp": 54,
	"./Uplayplus_LP_carousel_FCND_mobile.webp": 55,
	"./Uplayplus_LP_carousel_FCND_tablet.webp": 56,
	"./Uplayplus_LP_carousel_FH_desktop.webp": 57,
	"./Uplayplus_LP_carousel_FH_mobile.webp": 58,
	"./Uplayplus_LP_carousel_FH_tablet.webp": 59,
	"./Uplayplus_LP_carousel_GRBP_desktop.webp": 60,
	"./Uplayplus_LP_carousel_GRBP_mobile.webp": 61,
	"./Uplayplus_LP_carousel_GRBP_tablet.webp": 62,
	"./Uplayplus_LP_carousel_IFR_desktop.webp": 63,
	"./Uplayplus_LP_carousel_IFR_mobile.webp": 64,
	"./Uplayplus_LP_carousel_IFR_tablet.webp": 65,
	"./Uplayplus_LP_carousel_PoPFS_desktop.webp": 66,
	"./Uplayplus_LP_carousel_PoPFS_mobile.webp": 67,
	"./Uplayplus_LP_carousel_PoPFS_tablet.webp": 68,
	"./Uplayplus_LP_carousel_R6S_desktop.webp": 69,
	"./Uplayplus_LP_carousel_R6S_mobile.webp": 70,
	"./Uplayplus_LP_carousel_R6S_tablet.webp": 71,
	"./Uplayplus_LP_carousel_SCblacklist_desktop.webp": 72,
	"./Uplayplus_LP_carousel_SCblacklist_mobile.webp": 73,
	"./Uplayplus_LP_carousel_SCblacklist_tablet.webp": 74,
	"./Uplayplus_LP_carousel_TC2_desktop.webp": 75,
	"./Uplayplus_LP_carousel_TC2_mobile.webp": 76,
	"./Uplayplus_LP_carousel_TC2_tablet.webp": 77,
	"./Uplayplus_LP_carousel_TCTD2_desktop.webp": 78,
	"./Uplayplus_LP_carousel_TCTD2_mobile.webp": 79,
	"./Uplayplus_LP_carousel_TCTD2_tablet.webp": 80,
	"./Uplayplus_LP_carousel_TrialsRising_desktop.webp": 81,
	"./Uplayplus_LP_carousel_TrialsRising_mobile.webp": 82,
	"./Uplayplus_LP_carousel_TrialsRising_tablet.webp": 83,
	"./Uplayplus_LP_carousel_WDL_desktop.webp": 84,
	"./Uplayplus_LP_carousel_WDL_mobile.webp": 85,
	"./Uplayplus_LP_carousel_WDL_tablet.webp": 86,
	"./acv_slide_desktop.webp": 87,
	"./acv_slide_mobile.webp": 88,
	"./acv_slide_tablet.webp": 89,
	"./banners_logo_luna.webp": 90,
	"./banners_logo_stadia.webp": 91,
	"./fc6_slide_desktop.webp": 92,
	"./fc6_slide_logo.webp": 93,
	"./fc6_slide_mobile.webp": 94,
	"./fc6_slide_tablet.webp": 95,
	"./gm_slide_desktop.webp": 96,
	"./gm_slide_mobile.webp": 97,
	"./gm_slide_tablet.webp": 98,
	"./mad_slide_desktop.webp": 99,
	"./mad_slide_mobile.webp": 100,
	"./mad_slide_tablet.webp": 101,
	"./old_banners_assets/Ubisoft-plus-cloud-gaming-devices.webp": 102,
	"./old_banners_assets/Ubisoft-plus-crew-2-gold-edition.webp": 103,
	"./old_banners_assets/Ubisoft-plus-game-library-Ubisoft-Connect.webp": 104,
	"./pps_slide_desktop.webp": 105,
	"./pps_slide_mobile.webp": 106,
	"./pps_slide_tablet.webp": 107,
	"./rainbow_six_slide_desktop.webp": 108,
	"./rainbow_six_slide_mobile.webp": 109,
	"./rainbow_six_slide_ru_desktop.webp": 110,
	"./rainbow_six_slide_ru_mobile.webp": 111,
	"./rainbow_six_slide_ru_tablet.webp": 112,
	"./rainbow_six_slide_tablet.webp": 113,
	"./sp_slide_desktop.webp": 114,
	"./sp_slide_mobile.webp": 115,
	"./sp_slide_tablet.webp": 116,
	"./ubisoft-plus_rewards_program_desktop.webp": 117,
	"./ubisoft-plus_rewards_program_mobile.webp": 118,
	"./ubisoft-plus_rewards_program_tablet.webp": 119,
	"./ubisoft_plus_slide_desktop.webp": 120,
	"./ubisoft_plus_slide_mobile.webp": 121,
	"./ubisoft_plus_slide_tablet.webp": 122,
	"./valhala_fenyx_rysing_background_desktop.webp": 123,
	"./valhala_fenyx_rysing_background_mobile.webp": 124,
	"./valhala_fenyx_rysing_background_tablet.webp": 125,
	"./wdl_logo.webp": 126,
	"./wdl_slide_desktop.webp": 127,
	"./wdl_slide_mobile.webp": 128,
	"./wdl_slide_tablet.webp": 129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 130;